import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <h1 className="centered">dibs.fun</h1>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js